import logo from './logo.svg';
import './styles/App.css';
import './styles/devices.css';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, createHashRouter, RouterProvider, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import ProjectsPage from './pages/projects';
import Blog from './pages/blog';
import NotFound from './pages/notFound';
import { makeBlogPostURL } from './components/makeURL';
import BlogPost from './components/blogPostComponents/BlogPost';
import { allBlogPostDicts } from './content/allContent';

export const navbarHeight = "48px";

function App() {

  // 'light' or 'dark'
  // const [theme, setTheme] = useState(localStorage.theme);
  const [theme, setTheme] = useState(document.documentElement.classList.contains('dark') ? 'dark' : 'light');
  // const [theme, setTheme] = useState('light');

  // 'light-accent' or 'dark-accent'
  useEffect(() => {
    document.body.style.background = theme === 'light' ? 'rgb(236, 234, 226)' : 'rgb(58, 58, 60)';
  }, [theme]);

  return (
    <Routes>
      <Route path="/" element={<Home theme={theme} setTheme={setTheme} />} exact />
      <Route path="/projects" element={<ProjectsPage theme={theme} setTheme={setTheme} />} exact />
      <Route path="/blog" element={<Blog theme={theme} setTheme={setTheme} />} exact />
      {
        // All Blog Posts
        allBlogPostDicts.map((blogPostDict, idx) => {
          return <Route key={idx} path={makeBlogPostURL(blogPostDict["title"])} element={<BlogPost theme={theme} setTheme={setTheme} blogPostDict={blogPostDict} className='cursor-auto'/>} exact />
        })
      }
    </Routes>
  );
}

export default App;
